import { Divider, Typography, makeStyles } from "@material-ui/core";

import { DebouncedTextInput } from "ra-friendsofbabba";
import React from "react";
import { useTranslate } from "react-admin";
import { useWorkflowInput } from "ra-friendsofbabba";

const useStyles = makeStyles((theme) => ({
  container: {
    "& h6": {
      marginTop: theme.spacing(3),
      fontWeight: "bold",
      fontSize: 18,
      textTransform: "uppercase",
    },
    "& h6, & .MuiTypography-body2": {
      paddingTop: theme.spacing(1),
      paddingLeft: 16,
      paddingBottom: theme.spacing(1),
    },
    marginBottom: theme.spacing(3),
  },
}));

const TextContentInput = ({
  helperText,
  label,
  useHelp = true,
  useLabel = true,
  useWorkflow = true,
  disabled: disable,
  ...props
}) => {
  const { resource, source, record } = props;
  const classes = useStyles();
  const translate = useTranslate();

  const title = translate(label || `resources.${resource}.fields.${source}`);
  const help = translate(
    // Di default il TextInput prova a risolvere una proprietà di aiuto
    // che termina con nomecampo.help. Per evitare che la recuperi e non stampi
    // quella corrente, ne ho creata una diversa che si chiama help_long.
    helperText || `resources.${resource}.fields.${source}.help_long`
  );
  const contentLabel = translate(`app.label.content`);
  const { visible, disabled } = useWorkflowInput({ resource, source, record });
  if (!visible && useWorkflow) {
    return null;
  }
  return (
    <div className={classes.container}>
      {useLabel && <Typography variant="subtitle1">{title}</Typography>}
      {useLabel && <Divider />}
      {useHelp && <Typography variant="body2">{help}</Typography>}
      <DebouncedTextInput
        {...props}
        label={contentLabel}
        helperText={null}
        disabled={disable || (disabled && useWorkflow)}
      />
    </div>
  );
};

export default TextContentInput;
